<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card style="padding: 5px 20px">
      <v-btn style="position:absolute; right:0" icon @click="complete()" >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title>{{ $t('addContextItem') }}</v-card-title>
      <div>
        <v-file-input accept="image/*" :label="$t('chooseIcon')" :show-size="true" v-model="selectedIcon" @change="saveIcon"></v-file-input>
      </div>
      <div>
        <v-text-field :label="$t('setType')" type="text" v-model="type"/>
      </div>

      <v-card-actions>        
        <v-btn id="leftButton" text @click.stop="complete">Abbrechen</v-btn>
        <v-btn id="rightButton" @click.stop="addToElements" color="primary" :disabled="error || errorFileUpload">Hinzufügen</v-btn>
      </v-card-actions>
      <p class="error_custom" v-if="error">
        {{ $t('errorCustomElementsCount') }}
      </p>
      <p class="error_custom" v-if="errorFileUpload">
        {{ $t('errorCustomElementsIcon') }}
      </p>
    </v-card>
    <v-card style="overflow: auto; height:250px;">
      <v-row v-for="elem in modelingElements" :key="elem.id" no-gutters style="background-color: white; padding:5px;">
        <v-col cols="5" style="text-align:center;">
        {{elem.title}}
        </v-col>
        <v-col cols="5" style="text-align:center;">
        <img v-bind:src="elem.imageUrl" height="24px" width="24px"/>
        </v-col>
        <v-col cols="2" style="text-align:center;">
          <v-btn icon color="red" @click="removeElement(elem.id)">
                <v-icon>delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AdditionalContextInformationPicker",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      options: {
        width: 400,
        zIndex: 200,
      },
      icon: null,
      type: null,
      error:false,
      errorFileUpload: false,
      modelingElements: [],
      selectedIcon: null
    }
  },
  mounted(){
    this.initElements();
  },
  methods: {
    saveIcon(uploadedFile){
      this.errorFileUpload = false;
      if(uploadedFile == null) return;
      if(uploadedFile.type != null && uploadedFile.type != "" && uploadedFile.size != null){
        if(uploadedFile.size < 10240 && uploadedFile.type.includes("image")){
          var reader = new FileReader()
          
          reader.readAsDataURL(uploadedFile)
          reader.onload = () => {
              this.icon = reader.result;
          };
        }else{
          this.errorFileUpload = true;
          uploadedFile=null;
        }
      }else{
        this.errorFileUpload = true;
      }

    },
    initElements(){
      let array = [];
      if(this.$store.state.customModelingElements == null) return array;
      for(const [key, value] of Object.entries(this.$store.state.customModelingElements)){
        if(key != 'create.add') array.push(value);      
      }
      if(this.error && array.length <= 6) this.error = false;
      this.modelingElements = array;
    },
    async removeElement(elemId){
      await this.$store.dispatch("removeModelingElement", elemId);
      this.initElements();
    },
    onIconSelected(icon){
      this.icon = icon.name;
    },
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async addToElements() {
     
      if(this.modelingElements.length == 6){
        this.error = true;
      }else{
        const elem = {
          icon: this.icon,
          taskType: this.type
        };
        await this.$store.dispatch("addModelingElement", elem);
        this.resetFields();
        this.initElements()
      }    
    },
    resetFields(){
      this.icon = null;
      this.type = "";
      this.selectedIcon=null;
    },
    complete() {
      this.resetFields();
      this.dialog = false;
      window.location.reload();
    }
  }
};
</script>

<style>
.gridHalf{
  display: inline;
  width:50%;
}
</style>